<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
